<template>
  <b-container
    fluid="md"
    class="square-storecard-failure"
  >
    <b-row>
      <b-col>
        <div class="title pb-4">
          <span class="icon-container">
            <font-awesome-icon
              icon="circle-xmark"
              size="2x"
              class="icon"
              fixed-width
              color="red"
            />
          </span>
          <span class="h3 pr-4">
            Stored card details failed
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="payment-details">
          <h3>Failure Details</h3>
          <span class="label">Reason</span>
          <span
            class="value"
            data-cy="decline-code"
          >{{ errorCode }} ({{ errorDeclineCode }}) -- {{ errorMessage }} </span>
        </div>
      </b-col>
    </b-row>
    <square-response-debug-wrapper
      v-if="debug"
      :debug-data="debugData"
    />
  </b-container>
</template>

<script>
import DebugWrapper from './debug.vue'
import CommonTxnFields from './common-txn-fields'

export default {
  name: 'square-payment-storecard-failure',
  components: {
    'square-response-debug-wrapper': DebugWrapper
  },
  mixins: [
    CommonTxnFields
  ],
  props: {
    debug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    errorCode: function() {
      return this.error.code
    },
    errorDeclineCode: function() {
      return this.error.decline_code
    },
    errorMessage: function() {
      return this.error.message
    },
    error: function() {
      try {
        return this.$store.getters['square/processingResultFailure'].setup_intent.last_setup_error
      }
      catch (_err) {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .square-storecard-failure {
    .label {
      display: inline-block;
      width: 200px;
    }
  }
</style>
